/* POP! live print documents R12. One layout supplies SVG proof and vector PDF.
   Content is read from the current Shopify section on each preview/download. */
(function (host) {
  'use strict';
  const VERSION = 'POP-R12', W = 576, H = 360;
  const ink = '#18241d', yellow = '#ffe15c', muted = '#526058';
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
  const ascii = value => clean(value).replace(/[’‘]/g, "'").replace(/[“”]/g, '"').replace(/[—–−]/g, '-').replace(/×/g, 'x').replace(/…/g, '...').replace(/[↗→]/g, '');
  const xml = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&apos;'}[c]));

  function extract(root) {
    const text = selector => clean(root.querySelector(selector)?.textContent);
    const rules = Array.from(root.querySelectorAll('.pop-docs__rules [data-pop-rule]'), li => ({key:li.dataset.popRule, text:clean(li.querySelector('span').textContent)}));
    const image = root.querySelector('.pop-shot-game__stage > img');
    const facts = Array.from(root.querySelectorAll('.pop-cornhole-product__facts dd'), el => clean(el.textContent));
    const data = {
      title:text('[data-doc-title]'), price:text('[data-doc-price]'), priceLabel:text('[data-doc-price-label]'),
      logo:root.querySelector('[data-pop-logo]')?.dataset.printSrc, url:root.dataset.popProductUrl, image:image?.getAttribute('src'), rules,
      facts:facts.slice(0,3).join(' / '),
      digital:text('[data-intro-panel="rules"] .pop-arcade__dialog-note'),
      fire:text('[data-intro-panel="opponents"] > .pop-arcade__dialog-note'),
      responsible:text('.pop-shot-game__responsible')
    };
    if (!data.title || !data.price || !data.image || !data.logo || !data.url || rules.length !== 5 || !data.digital || !data.fire) throw Error('The live product section is incomplete. Please reload and try again.');
    const url = new URL(data.url);
    if (url.protocol !== 'https:') throw Error('The product link must use HTTPS.');
    return data;
  }

  function wrap(value, font, size, width) {
    const words = ascii(value).split(' '), lines = []; let line = '';
    for (const word of words) {
      if (font.widthOfTextAtSize(word,size) > width) throw Error('Print content contains a word that is too long.');
      const candidate = line ? line+' '+word : word;
      if (line && font.widthOfTextAtSize(candidate,size) > width) { lines.push(line); line=word; }
      else line=candidate;
    }
    if (line) lines.push(line);
    return lines;
  }

  function scene(data, fonts, qr, stamp) {
    const out=[];
    const rect=(x,y,w,h,color)=>out.push({kind:'rect',x,y,w,h,color});
    const line=(text,x,y,size=10,bold=false,color=ink)=>out.push({kind:'text',text:ascii(text),x,y,size,bold,color});
    const block=(text,x,y,width,size,bold=false,max=99)=>{
      const lines=wrap(text,bold?fonts.bold:fonts.regular,size,width);
      if (lines.length>max) throw Error('Updated content needs a print-layout adjustment before downloading.');
      lines.forEach((t,i)=>line(t,x,y+i*size*1.3,size,bold));
      return lines.length*size*1.3;
    };
    rect(0,0,W,H,'#ffffff');rect(0,0,W,7,yellow);
    out.push({kind:'logo',x:68.5,y:8,w:130,h:130*740/820});
    line('GAMEDAY FLAGS / TABLETOP GAMES',17,133,7.3,true);
    out.push({kind:'image',x:17,y:140,w:232,h:130.5});
    block(data.facts,17,282,232,7.3,false,2);
    block(data.title,17,307,232,10,true,2);
    line(data.price,17,339,20,true);
    block(data.priceLabel,17,352,232,7,false,1);
    rect(269,20,1,263,'#d7ddd8');
    line("HERE'S HOW YOU PLAY.",288,28,15,true);
    let y=55;
    data.rules.forEach((rule,i)=>{
      rect(288,y-11,20,19,yellow);line(String(i+1).padStart(2,'0'),291,y+2,9,true);
      const used=block(rule.text,319,y+1,238,11.5,true,2);
      y+=Math.max(30,used+5);
    });
    if(y>206)throw Error('Updated rules need a print-layout adjustment before downloading.');
    line('ON-SCREEN GAME',288,209,7.5,true);
    block(data.digital+' '+data.fire,288,220,268,7.3,false,7);
    line('SCAN TO PLAY + SHOP',288,299,9,true);
    block(data.url.replace(/^https:\/\//,'').replace(/\/products\/.*/,''),288,313,198,10,true,1);
    block(data.responsible,288,328,196,7.4,false,2);
    // Four-module quiet zone is part of the QR's white field.
    const count=qr.getModuleCount(), unit=62/(count+8);
    rect(499,287,62,62,'#ffffff');
    for(let r=0;r<count;r++) for(let c=0;c<count;c++) if(qr.isDark(r,c)) rect(499+(c+4)*unit,287+(r+4)*unit,unit,unit,ink);
    line(stamp,288,356,6.5,false,muted);
    return out;
  }

  function svgFor(commands, format, imageUrl, logoUrl) {
    const height=format==='tent'?792:396;
    const render=commands.map(c=>{
      if(c.kind==='rect')return `<rect x="${c.x}" y="${c.y}" width="${c.w}" height="${c.h}" fill="${c.color}"/>`;
      if(c.kind==='logo')return `<image x="${c.x}" y="${c.y}" width="${c.w}" height="${c.h}" href="${xml(logoUrl)}" preserveAspectRatio="xMidYMid meet"/>`;
      if(c.kind==='image')return `<image x="${c.x}" y="${c.y}" width="${c.w}" height="${c.h}" href="${xml(imageUrl)}" preserveAspectRatio="xMidYMid meet"/>`;
      return `<text x="${c.x}" y="${c.y}" font-family="Arial,Helvetica,sans-serif" font-size="${c.size}" font-weight="${c.bold?700:400}" fill="${c.color}">${xml(c.text)}</text>`;
    }).join('');
    return `<svg xmlns="http://www.w3.org/2000/svg" role="img" aria-label="POP! ${format==='tent'?'folding table tent':'rules card'} print proof" viewBox="0 0 612 ${height}" width="612" height="${height}"><rect width="612" height="${height}" fill="white"/>${format==='tent'?`<g transform="translate(594 378) rotate(180)">${render}</g><path d="M18 396H594" stroke="#9da79f" stroke-width=".5" stroke-dasharray="3 4"/><g transform="translate(18 414)">${render}</g>`:`<g transform="translate(18 18)">${render}</g>`}</svg>`;
  }

  async function build(data, deps, imageBytes, format='tent', date=new Date(), logoBytes) {
    const P=deps.PDFLib, doc=await P.PDFDocument.create();
    const fonts={regular:await doc.embedFont(P.StandardFonts.Helvetica),bold:await doc.embedFont(P.StandardFonts.HelveticaBold)};
    const qr=deps.qrcode(0,'M'); qr.addData(data.url); qr.make();
    const stamp=`Current page / ${date.toISOString().slice(0,10)} / ${VERSION}`;
    const commands=scene(data,fonts,qr,stamp);
    // Third-party fonts are avoided; all PDFs embed the standard Helvetica metrics.
    const image=await doc.embedPng(imageBytes);
    if(!logoBytes)throw Error('The current POP logo is required for printing.');
    const logo=await doc.embedPng(logoBytes);
    const face=doc.addPage([W,H]);
    const rgb=hex=>P.rgb(parseInt(hex.slice(1,3),16)/255,parseInt(hex.slice(3,5),16)/255,parseInt(hex.slice(5,7),16)/255);
    commands.forEach(c=>{
      if(c.kind==='rect')face.drawRectangle({x:c.x,y:H-c.y-c.h,width:c.w,height:c.h,color:rgb(c.color)});
      if(c.kind==='text')face.drawText(c.text,{x:c.x,y:H-c.y,size:c.size,font:c.bold?fonts.bold:fonts.regular,color:rgb(c.color)});
      if(c.kind==='logo')face.drawImage(logo,{x:c.x,y:H-c.y-c.h,width:c.w,height:c.h});
      if(c.kind==='image')face.drawImage(image,{x:c.x,y:H-c.y-c.h,width:c.w,height:c.h});
    });
    const embedded=await doc.embedPage(face);doc.removePage(0);
    const page=doc.addPage([612,format==='tent'?792:396]);
    if(format==='tent'){
      page.drawPage(embedded,{x:594,y:774,width:W,height:H,rotate:P.degrees(180)});
      page.drawPage(embedded,{x:18,y:18,width:W,height:H});
      page.drawLine({start:{x:18,y:396},end:{x:594,y:396},thickness:.5,dashArray:[3,4],color:rgb('#9da79f')});
    }else page.drawPage(embedded,{x:18,y:18,width:W,height:H});
    doc.setTitle(`POP! Cornhole - ${format==='tent'?'Table Tent':'Rules Card'}`);doc.setAuthor('Gameday Flags');doc.setSubject('Current product-page rules and offer');doc.setCreationDate(date);
    let binary='';for(const n of imageBytes)binary+=String.fromCharCode(n);
    const imageUrl='data:image/png;base64,'+(typeof btoa==='function'?btoa(binary):Buffer.from(imageBytes).toString('base64'));
    let logoBinary='';for(const n of logoBytes)logoBinary+=String.fromCharCode(n);
    const logoUrl='data:image/png;base64,'+(typeof btoa==='function'?btoa(logoBinary):Buffer.from(logoBytes).toString('base64'));
    return {pdf:await doc.save(),svg:svgFor(commands,format,imageUrl,logoUrl),data,commands};
  }

  const api={VERSION,extract,build,wrap};
  if(typeof module==='object'&&module.exports){module.exports=api;return;}
  host.PopLiveDocuments=api;
  const scripts=new Map();
  function loadScript(url,global){
    if(host[global])return Promise.resolve(host[global]);
    if(!scripts.has(url))scripts.set(url,new Promise((resolve,reject)=>{
      const el=document.createElement('script');el.src=url;el.onload=()=>resolve(host[global]);el.onerror=()=>{scripts.delete(url);el.remove();reject(Error('Print tools could not load. Please try again.'));};document.head.append(el);
    }));return scripts.get(url);
  }
  function init(root){
    if(root.dataset.popDocsBound)return;root.dataset.popDocsBound='1';
    const studio=root.querySelector('[data-pop-docs]');if(!studio)return;
    const dialog=studio.querySelector('dialog'),select=studio.querySelector('[data-doc-format]'),status=studio.querySelector('[data-doc-status]'),preview=studio.querySelector('[data-doc-preview]');
    const buttons=[...studio.querySelectorAll('[data-doc-download],[data-doc-print]')];
    let trigger=null, revision=0;
    const deps=()=>Promise.all([loadScript(studio.dataset.pdfLib,'PDFLib'),loadScript(studio.dataset.qrLib,'qrcode')]).then(([PDFLib,qrcode])=>({PDFLib,qrcode}));
    async function current(){
      const url=new URL(root.dataset.popProductUrl);url.searchParams.set('section_id',root.dataset.popSectionId);
      // Same-origin public endpoint; credentials/tokens never enter printable content.
      url.protocol=location.protocol;url.host=location.host;
      const response=await fetch(url,{cache:'no-store'});if(!response.ok)throw Error('Cannot refresh the live rules. Please try again.');
      const html=new DOMParser().parseFromString(await response.text(),'text/html'),fresh=html.querySelector('[data-pop-document-root]');
      if(!fresh)throw Error('The current product section is unavailable. Please try again.');
      return extract(fresh);
    }
    async function generate(format){
      const [data,tools]=await Promise.all([current(),deps()]);
      const response=await fetch(new URL(data.image,location.href));if(!response.ok)throw Error('The product photo could not load. Please try again.');
      const logo=await fetch(new URL(data.logo,location.href));if(!logo.ok)throw Error('The POP logo could not load. Please try again.');
      return build(data,tools,new Uint8Array(await response.arrayBuffer()),format,new Date(),new Uint8Array(await logo.arrayBuffer()));
    }
    async function refresh(action){
      const run=++revision;buttons.forEach(b=>b.disabled=true);select.disabled=true;status.textContent='Refreshing current rules, photo and price…';
      try{
        const format=select.value,result=await generate(format);if(run!==revision)return;
        preview.innerHTML=result.svg;status.textContent=`Current page checked. ${format==='tent'?'Letter-size tent · fold on the center line.':'Half-letter rules card · print flat.'}`;
        buttons.forEach(b=>b.disabled=false);
        if(action==='download'){
          const href=URL.createObjectURL(new Blob([result.pdf],{type:'application/pdf'})),a=document.createElement('a');a.href=href;a.download=`POP_Cornhole_${format==='tent'?'Table_Tent':'Rules_Card'}.pdf`;dialog.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(href),60000);
        }
        if(action==='print'){
          const frame=document.createElement('iframe');frame.title='POP! print document';frame.style.cssText='position:fixed;left:-9999px;width:1px;height:1px;border:0';dialog.append(frame);
          frame.onload=()=>{const win=frame.contentWindow;win.onafterprint=()=>frame.remove();win.focus();win.print();};
          frame.srcdoc=`<!doctype html><html><head><title>POP! Cornhole</title><style>@page{size:8.5in ${format==='tent'?'11':'5.5'}in;margin:0}html,body{margin:0}svg{display:block;width:8.5in;height:${format==='tent'?'11':'5.5'}in}</style></head><body>${result.svg}</body></html>`;
        }
      }catch(e){if(run===revision){preview.replaceChildren();status.textContent=e.message+' Close and reopen to retry.';}}
      finally{if(run===revision)select.disabled=false;}
    }
    function open(format,from){
      trigger=from||document.activeElement;select.value=format==='card'?'card':'tent';
      root.querySelectorAll('dialog[open]').forEach(d=>{if(d!==dialog)d.close();});
      if(!dialog.open)dialog.showModal();refresh();
    }
    root.querySelectorAll('[data-pop-doc-open]').forEach(link=>link.addEventListener('click',e=>{e.preventDefault();open(link.dataset.popDocOpen,link);}));
    studio.querySelector('[data-doc-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>{revision++;trigger?.focus({preventScroll:true});});
    select.addEventListener('change',()=>refresh());
    studio.querySelector('[data-doc-download]').addEventListener('click',()=>refresh('download'));
    studio.querySelector('[data-doc-print]').addEventListener('click',()=>refresh('print'));
    const minis=[...root.querySelectorAll('[data-pop-doc-mini]')];
    if(minis.length){
      const observer=new IntersectionObserver(entries=>{if(!entries.some(e=>e.isIntersecting))return;observer.disconnect();
        Promise.all(minis.map(async el=>{try{el.innerHTML=(await generate(el.dataset.popDocMini)).svg;}catch(e){el.textContent='Open live print proof';}}));
      },{rootMargin:'150px'});observer.observe(minis[0]);
    }
    const requested=new URLSearchParams(location.search).get('pop-print');if(requested)open(requested);
  }
  const start=()=>document.querySelectorAll('[data-pop-document-root]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})(typeof window!=='undefined'?window:globalThis);
